import { Spinner } from '@/shared/components/ui/spinner'

export function LoadingBlock({ label = 'Загрузка...' }: { label?: string }) {
  return (
    <div className="flex min-h-36 items-center justify-center gap-2 rounded-2xl border border-[var(--panel-border)] bg-[var(--panel)]">
      <Spinner />
      <span className="text-sm text-[var(--color-text-soft)]">{label}</span>
    </div>
  )
}
